import React from 'react';
import { AlertCircle } from 'lucide-react';
export function LeadSection() {
  return <section className="py-12 px-4 bg-white" data-id="element-106">
      <div className="max-w-3xl mx-auto prose prose-lg prose-emerald" data-id="element-107">
        <h2 className="text-3xl font-bold text-gray-900 mb-6 border-l-4 border-emerald-500 pl-4" data-id="element-108">
          Usted conoce ese miedo...
        </h2>

        <p className="text-gray-700 mb-6" data-id="element-109">
          Ese momento en el que mira el glucómetro y el número parece una
          condena. O cuando siente ese pinchazo extraño en los pies al acostarse
          y piensa: <strong data-id="element-110">"¿Será que voy camino a lo peor?"</strong>.
        </p>

        <div className="bg-gray-50 p-6 rounded-lg border border-gray-200 mb-8" data-id="element-111">
          <p className="text-gray-800 italic font-medium" data-id="element-112">
            "En Uruguay, nos enseñaron que si tienes azúcar alta, te toca
            pastilla de por vida y despedirte del pan, del postre y de las
            reuniones familiares. Pero es una mentira."
          </p>
        </div>

        <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-113">
          La verdad sobre el "Número Seguro"
        </h3>

        <p className="text-gray-700 mb-6" data-id="element-114">
          ¿Sabía que el 100 de glucosa ya no es el número seguro que le dijeron?
          Las pautas están cambiando, y lo que antes se consideraba "normal" hoy
          es una señal de alerta roja de que su sistema metabólico está pidiendo
          auxilio.
        </p>

        <div className="flex items-start gap-4 bg-red-50 p-4 rounded-lg text-red-800 mb-6" data-id="element-115">
          <AlertCircle className="h-6 w-6 flex-shrink-0 mt-1" data-id="element-116" />
          <p className="text-sm md:text-base" data-id="element-117">
            <strong data-id="element-118">Dato alarmante:</strong> La mayoría de los tratamientos
            convencionales solo "tapan" el síntoma mientras la causa raíz sigue
            avanzando silenciosamente.
          </p>
        </div>
      </div>
    </section>;
}